import Swiper from 'swiper/bundle';

const slider = {
	swiperObj : [],

	init: function() {
		const sliderItems = document.querySelectorAll(".slider__items");
		if( sliderItems ){
			sliderItems.forEach(e => {
				this.swiperObj.push(new Swiper(
					e,
					{
						slidesPerView: 'auto',
						spaceBetween: 32,
						navigation: {
							prevEl: '.slider__button__prev',
							nextEl: '.slider__button__next'
						},
					}
				));
			})
		}
	},
};

export default slider;